import { render, staticRenderFns } from "./serviceEntry.vue?vue&type=template&id=e27867de&scoped=true"
import script from "./serviceEntry.vue?vue&type=script&lang=js"
export * from "./serviceEntry.vue?vue&type=script&lang=js"
import style0 from "./serviceEntry.vue?vue&type=style&index=0&id=e27867de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27867de",
  null
  
)

export default component.exports